import { render, staticRenderFns } from "./CreateManufacturingItemDialog.vue?vue&type=template&id=3d9cb8ec&scoped=true&"
import script from "./CreateManufacturingItemDialog.vue?vue&type=script&lang=js&"
export * from "./CreateManufacturingItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9cb8ec",
  null
  
)

export default component.exports